<template>
	<div class="personalCenter">
		<scroller :on-infinite="infinite" :on-refresh="refresh" ref="myscroller">
			<div class="inforBox">
				<div class="btn_box" v-if="lableType == '2'"><a class="share" @click="codeFn('share')"></a></div>
				<div class="btn_box" v-else><a class="share" @click="shareFn"></a></div>
				<div class="userBox">
					<div class="pic fl" :style="'background-image: url(' + userImg + ');'"></div>
					<div class="txtBox">
						<h3 class="overflow_clear">账户:{{userCard}}</h3>
						<div class="pub_list">
							<div class="wz_box">
								<p>余额:{{userMoney}}</p>
							</div>
							<img class="code" src="../../assets/code-ico.png" @click="codeFn('pay')" />
						</div>
					</div>
				</div>
			</div>
			<div class="btn-box2">
				<a href="javascript:;" class="recharge-btn" @click="linkRecharge"><i class="ico_1"></i>去充值</a>
				<a class="turnCard-btn" @click="scanQRCodeStart"><i class="ico_2"></i>去绑卡</a>
			</div>
			<div class="tabBox">
				<a class="li" :class="tabIdx == 0 ? 'on' : ''" @click="tabChange(0)">消费明细</a>
				<a class="li" :class="tabIdx == 1 ? 'on' : ''" @click="tabChange(1)" v-if="lableType == '2'">业绩报表</a>
				<a class="li" :class="tabIdx == 1 ? 'on' : ''" @click="tabChange(1)" v-if="lableType == '1'">优惠券</a>
			</div>
			<div class="recordBox" v-show="tabIdx == 0">
				<ul>
					<li v-for="(item, index) in recordLists" :key="index">
						<div class="time">{{item.CHANGEDATE}}</div>
						<div class="name">{{item.STORENAME}}</div>
						<div class="txt">
							<span v-if="item.BILLTYPE == 'RETAIL'">消费</span>
							<span v-else-if="item.BILLTYPE == 'RECHARGE1'">充值</span>
							<span v-else-if="item.BILLTYPE == 'RECHARGE2'">退卡</span>
							<span v-else-if="item.BILLTYPE == 'RECHARGE3'">转卡</span>
						</div>
						<div class="money">
							<span v-if="item.BILLTYPE == 'RETAIL'" style="color:#f30;">{{item.CHANGEAMT}}</span>
							<span v-else-if="item.BILLTYPE == 'RECHARGE1'" style="color:#4b0;">+{{item.CHANGEAMT}}</span>
							<span v-else-if="item.BILLTYPE == 'RECHARGE2'" style="color:#f90;">{{item.CHANGEAMT}}</span>
							<span v-else-if="item.BILLTYPE == 'RECHARGE3'" style="color:#29B4F0;">{{item.CHANGEAMT}}</span>
						</div>
					</li>
				</ul>
			</div>
			<div class="couponBox" v-show="tabIdx == 1 && lableType == '1'">
				<ul>
					<li v-for="(item,index) in couponLists" :key="index" @click="getCouponCode(item.QVOUCHER)">
						<div class="cont">
							<div class="price">
								<p class="yuan">￥<big>{{item.PRICE}}</big></p>
								<small>满{{item.TOPPRICE}}可用</small>
							</div>
							<div class="txt-box">
								<h3>{{item.QVOUCHER}}</h3>
								<p>有效期至：{{item.END_BEGIN}}</p>
							</div>
							<a href="javascript:;" class="btn">立即使用</a>
						</div>
						<div class="bottom">
							<p>{{item.SHUOMIN2}}</p>
						</div>
					</li>
				</ul>
			</div>
			<div class="statisticsBox" v-show="tabIdx == 1 && lableType == '2'">
				<h2 class="title">推销卡排名及金额</h2>
				<div class="box mb20">
					<div class="li">
						<div class="fl">
							<p>今日排名</p>
							<big>{{sellInfor.RANKDAY}}</big>
						</div>
						<div class="right">
							<p>今日推销卡金额</p>
							<big style="color: #4b0;">{{sellInfor.SUMDAYAMT}}</big>
						</div>
					</div>
					<div class="li">
						<div class="fl">
							<p>本月排名</p>
							<big>{{sellInfor.RANKMONTH}}</big>
						</div>
						<div class="right">
							<p>本月推销卡金额</p>
							<big style="color: #f90;">{{sellInfor.SUMMONTHAMT}}</big>
						</div>
					</div>
					<div class="li">
						<div class="fl">
							<p>年度排名</p>
							<big>{{sellInfor.RANKNO}}</big>
						</div>
						<div class="right">
							<p>年度推销卡金额</p>
							<big style="color: #29B4F0;">{{sellInfor.SUMTOTAMT}}</big>
						</div>
					</div>
				</div>
				<h2 class="title">推销卡记录</h2>
				<div class="listsBox">
					<ul>
						<li v-for="(item,index) in cardLists" :key="index">
							<div class="time">{{item.JOINDATE}}</div>
							<div class="name">{{item.mobile}}</div>
							<div class="money">￥{{item.TOTAMT}}</div>
						</li>
					</ul>
				</div>
			</div>
		</scroller>
		
		<!--支付二维码与推销员分享二维码弹层-开始-->
		<div class="codeMask" v-if="codeShow || couponCodeShow" @click="codeFn">
			<div class="cont"><img :src="codeImg" />
				<p>{{codeText}}</p>
			</div>
		</div>
		<!--支付二维码与推销员分享二维码弹层-结束-->
		
		<!--客户分享指示弹层-开始-->
		<div class="customTipsMask" v-if="shareShow" @click="shareFn">
			<img src="../../assets/sharePic_share.png" />
		</div>
		<!--客户分享指示弹层-结束-->
		
		<!--转卡提示-->
		<v-askpopup :askpopup="askpopup" @cancel="turnCardCancel" @confirm="turnCardConfirm"></v-askpopup>
		
		<!--提示框-->
		<v-tips :isshow="tipshow" :tips="tips"></v-tips>
		
		<!--售后电话-->
		<div style="height: 44px;"></div>
		<a class="kefu" href="tel:0551-65639551"><i class="ico"></i>客服：0551-65639551</a>
	</div>
</template>

<style scoped="scoped">
	._v-container{height:calc(100% - 44px) !important;}
</style>

<script>
	import vTips from "../../common/tip"
	import vAskpopup from "../../common/askpopup"
	import api from "../../api/api"
	var parma1 = {
		page:1,
		size:10
	};
	var parma2 = {
		page:1,
		size:10
	};
	var parma3 = {
		page:1,
		size:10
	};
	export default{
		data () {
			return {
				tipshow:false,
				tips:'',
				isRefresh:true,
				userImg:'',
				userCard:'',
				userMoney:'',
				tabIdx:0,
				tabIdx1:false,
				tabIdx2:false,
				shareShow:false,
				codeShow:false,
				couponCodeShow:false,
				recordLists:[],
				sellInfor:{},
				cardLists:[],
				lableType:'',
				codeImg:'',
				codeText:'',
				couponLists:[],
				askpopup:{
					title:'',
					tips:'',
					show:false
				},
				cardKey:'',
				page1:1,
				page2:1,
				page3:1
			}
		},
		components:{vTips,vAskpopup},
		mounted(){
			// return false; //测试
			this.tabIdx1 = false;
			this.userImg = window.__CFG.WX_IMG;
			this.userCard = window.__CFG.CARD_N;
			this.consumeData(1);
			if(localStorage.getItem("WXSDK") && localStorage.getItem("WXSDK").appId){
			}else{
				var url = window.location.href;
				api.getsdk({"url":url},(res) => {
					if(res.status == 1){
						//微信SDK
						var data = res.data.data;
						var WXS_DK = {
							debug: false,
							appId: data.appId,
							timestamp: data.timestamp,
							nonceStr: data.nonceStr,
							signature: data.signature,
							jsApiList: ['checkJsAPi','onMenuShareAppMessage','onMenuShareTimeline','scanQRCode','chooseWXPay','updateTimelineShareData']
						};
						localStorage.setItem("WXSDK",WXS_DK);
						window.WXJS_CFG = WXS_DK;
						wx.config(window.WXJS_CFG);
						setTimeout(() => {
							//客户分享
							var title = "ENJOY'me",
								desc = "电子消费卡",
								link = window.__CFG.URL + "/card/getcode?parentId=" + window.__CFG.UserId,
								imgUrl = "http://www.enjoyme.cn/public/front_images/logo.png";
							api.webshare(title,desc,link,imgUrl);
						},200);
					}else{
						// alert("请求失败");
						api.tipload(this,res.msg);
					}
				});
			}
		},
		methods:{
			//推销员推销信息
			sellData(){
				var that = this;
				api.selldata({},(res) => {
					if(res.status == 1){
						that.sellInfor = res.data.rankList[0] || {
							RANKDAY:0,
							SUMDAYAMT:0,
							RANKMONTH:0,
							SUMMONTHAMT:0,
							RANKNO:0,
							SUMTOTAMT:0,
						};
					}else{
						// alert("请求失败");
						api.tipload(that,res.msg);
					}
				});
			},
			//消费记录数据
			consumeData(setpage){
				var that = this;
				parma1.page = setpage ? setpage : that.page1;
				api.consumerecord(parma1,(res) => {
					console.log(parma1);
//					console.log(res)
					if(res.status == 1){
						// console.log("用户",window.__CFG.Authorization);
						// console.log("用户状态",window.__CFG.lableType);
						that.lableType = window.__CFG.lableType;
						// console.log("lableType",window.__CFG.lableType);
						if(setpage){
							that.page1 = 1;
							that.recordLists = res.data.list;
							that.userMoney = res.data.userInfo.REMAIN;
						}
						else {
							if(res.data.list.length > 0){
								if(res.data.list.length < 10){
									that.isRefresh = false;
								};
								if(parma1.page > 1){
									that.recordLists = that.recordLists.concat(res.data.list);
								};
								that.page1 = parma1.page + 1;
							}else{
								that.isRefresh = false;
							};
						}
					}
					else{
						if(res.code == 1001){
							if(localStorage.getItem("Authorization")){
								localStorage.removeItem("Authorization");
								localStorage.removeItem("LableType");
							}
							api.login({},(re) => {
								if(re.status == 1){
									window.__CFG.Authorization = re.data.Authorization;
									window.__CFG.lableType = re.data.userInfo.LABELTYPE;
									localStorage.setItem("Authorization",re.data.Authorization);
									localStorage.setItem("LableType",re.data.userInfo.LABELTYPE);
									parma1.page = 1;
									that.page1 = 1;
									that.isRefresh = true;
									that.consumeData(1);
								}else{
									// alert('请求失败');
									api.tipload(that,re.msg);
								}
							});
						}
						// alert("请求失败");
						api.tipload(that,res.msg);
					}
				});
			},
			//推销员推销记录
			sellRecord(setpage){
				var that = this;
				parma2.page = setpage ? setpage : that.page2;
				api.sellrecord(parma2,(res) => {
					if(res.status == 1){
						//遍历数组 手机号加密
						res.data.forEach((item) => {
							item.mobile = item.PHONE.substr(0,3)+"****"+item.PHONE.substr(7);
						});
						
						if(setpage){
							that.page2 = 1;
							that.cardLists = res.data;
						} 
						else {
							if(res.data.length > 0){
								if(res.data.length < 10){
									that.isRefresh = false;
								};
								if(parma2.page > 1){
									that.cardLists = that.cardLists.concat(res.data);
								};
								that.page2 = parma2.page + 1;
							}else{
								that.isRefresh = false;
							};
						}
					}else{
						if(res.code == 1001){
							parma2.page = 1;
							that.page2 = 1;
							that.isRefresh = true;
							that.sellRecord(1);
						}
						// alert("请求失败");
						api.tipload(that,res.msg);
					}
				});
			},
			//优惠券列表数据
			couponData(setpage){
				var that = this;
				parma3.page = setpage ? setpage : that.page3;
				api.getcoupon(parma3,(res) => {
					if(res.status == 1){					
						if(setpage){
							that.page3 = 1;
							that.couponLists = res.data;
						} 
						else {
							if(res.data.length > 0){
								if(res.data.length < 10){
									that.isRefresh = false;
								};
								if(parma3.page > 1){
									that.couponLists = that.couponLists.concat(res.data);
								};
								that.page3 = parma3.page + 1;
							}else{
								that.isRefresh = false;
							};
						}
					}else{
						if(res.code == 1001){
							parma3.page = 1;
							that.page3 = 1;
							that.isRefresh = true;
							that.couponData(1);
						}
						// alert("请求失败");
						api.tipload(that,res.msg);
					}
				});
			},
			//优惠券码展示
			getCouponCode(e){
				api.getcouponcode({"code":e},(res) => {
					if(res.status == 1){
						var src = "data:image/png;base64," + res.data.qrcode;
						this.codeImg = src;
						this.codeText = '券码:' + e;
						this.couponCodeShow = true;
					}else{
						// alert("请求失败");
						api.tipload(this,res.msg);
					}
				});
			},
			//tab切换
			tabChange(e){
				this.tabIdx = e;
				if(this.tabIdx1 == false && e == 1 && this.lableType == '2'){
					parma2.page = 1;
					this.page2 = 1;
					this.isRefresh = true;
					this.sellData();
					this.sellRecord(1);
				}
				if(e == 1 && this.lableType == '2'){
					this.tabIdx1 = true;
				}
				
				if(this.tabIdx2 == false && e == 1 && this.lableType == '1'){
					parma3.page = 1;
					this.page3 = 1;
					this.isRefresh = true;
					this.couponData(1);
				}
				if(e == 1 && this.lableType == '1'){
					this.tabIdx2 = true;
				}				
			},
			//跳转充值页
			linkRecharge(){
				if(localStorage.getItem("isRefund")){
					return false;
				}

				if (window.__CFG.ParentId == ''){
					this.$router.push('/card/recharge/pay');
				} else {
					this.$router.push({
						path: '/card/recharge/pay',
						query: { parentId: window.__CFG.ParentId }
					});
				}

			},
			//支付二维码展示
			codeFn(e){
				if(e == 'share'){ //推广码
					var url = window.__CFG.URL + '/card/getcode';
					if(url.indexOf("?") == -1){
						url = url + "?parentId=" + window.__CFG.UserId;
					}else{
						url = url + "&parentId=" + window.__CFG.UserId;
					}
					api.getqrcode({"url":url},(res) => {
						if(res.status == 1){
							this.codeImg = res.data.QRCODE;
							this.codeText = '分享二维码';
							this.codeShow = !this.codeShow;
						}else{
							// alert("请求失败");
							api.tipload(this,res.msg);
						}
					});
				} else if(e == 'pay'){
					if(localStorage.getItem("isRefund")){
						return false;
					}
					api.getpaycode({},(res) => {
						if(res.status == 1){
							var src = "data:image/png;base64," + res.data.qrcode;
							this.codeImg = src;
							this.codeText = '支付二维码';
							this.codeShow = !this.codeShow;
						}else{
							console.log("请求失败");
							api.tipload(this,res.msg);
						}
					});
				} else{
					if(this.couponCodeShow){ //优惠券码关闭
						this.couponCodeShow = false;
					}else{ //支付二维码关闭
						if(this.codeImg.indexOf("data:image/png;base64,") == 0){
							parma1.page = 1;
							this.page1 = 1;
							this.isRefresh = true;
							this.consumeData(1);
							if(this.lableType == '2'){
								parma2.page = 1;
								this.page2 = 1;
								this.isRefresh = true;
								this.sellData();
								this.sellRecord(1);
							}
						};
						this.codeShow = !this.codeShow;
					}
					this.codeImg = '';
					this.codeText = '';
				}
			},
			//客户分享
			shareFn(){
				this.shareShow = !this.shareShow;
				var title = "ENJOY'me",
					desc = "电子消费卡",
					link = window.__CFG.URL + "/card/getcode?parentId=" + window.__CFG.UserId,
					imgUrl = "http://www.enjoyme.cn/public/front_images/logo.png";
				api.webshare(title,desc,link,imgUrl);
			},
			//扫码获取卡信息
			scanQRCodeStart(){
				if(localStorage.getItem("isRefund")){
					return false;
				}
				var that = this;
				wx.scanQRCode({
					needResult: 1, // 默认为0，扫描结果由微信处理，1则直接返回扫描结果，
					scanType: ["qrCode","barCode"], // 可以指定扫二维码还是一维码，默认二者都有
					success: function (ret) {
						let result = ret.resultStr; // 当needResult 为 1 时，扫码返回的结果
						// alert("key值"+result);
						api.getconsumecard({"key":result},(res) => {
							if(res.status == 1){
								that.askpopup = {
									title:'卡号：' + res.data.CARDNO,
									tips:'卡里余额还剩' + res.data.REMAIN + '，确定绑卡？',
									show:true
								};
								that.cardKey = res.data.ENCRYPTED_RAW;
							}else{
								// console.log("请求失败");
								api.tipload(that,res.msg);
							}
						});
					}
				});
			},
			turnCardCancel(){
				this.askpopup = {
					title:'',
					tips:'',
					show:false
				}
			},
			turnCardConfirm(){
				api.bindconsumecard({"key":this.cardKey},(res) => {
					if(res.status == 1){
						parma1.page = 1;
						this.page1 = 1;
						this.isRefresh = true;
						this.consumeData(1);
						if(this.lableType == '2'){
							parma2.page = 1;
							this.page2 = 1;
							this.isRefresh = true;
							this.sellData();
							this.sellRecord(1);
						}else if(this.lableType == '1'){
							parma3.page = 1;
							this.page3 = 1;
							this.isRefresh = true;
							this.couponData(1);
						};
					}else{
						// console.log("请求失败");
					}
					api.tipload(this,res.msg);
					this.askpopup = {
						title:'',
						tips:'',
						show:false
					};
				});
			},
			//下拉刷新
			refresh(done){
				// return false; //测试
				// api.getrefund({},(res) => {
				// 	if(res.status == 1){
				// 		if(res.data.status == 1){
				// 			console.log("已电话申请，未提交银行卡",res.data.status);
				// 			this.$router.go(-2);
				// 			return false;
				// 		}
				// 		else if(res.data.status == 2){
				// 			console.log("已提交银行卡",res.data.status);
				// 			localStorage.setItem("isRefund",true);
				// 		}
				// 	}else{
				// 		api.tipload(this,res.msg);
				// 	}
				// });
				parma1.page = 1;
				parma2.page = 1;
				parma3.page = 1;
				this.page1 = 1;
				this.page2 = 1;
				this.page3 = 1;
				this.isRefresh = true;
				setTimeout(() => {
					this.consumeData(1);
					// this.tabIdx1 == false;
					// this.tabIdx2 == false;
					if(this.lableType == '2'){
						this.sellData();
						this.sellRecord(1);
					}else if(this.lableType == '1'){
						this.couponData(1);
					}
				  	this.$refs.myscroller.finishPullToRefresh();//刷新完毕关闭刷新的转圈圈
				}, 1500);
			},
			//上拉加载
			infinite(done){
				// return false; //测试
				if(this.tabIdx == 0){
					this.consumeData();
				}
				else if(this.tabIdx == 1 && this.lableType == '2'){
					this.sellRecord();
				}
				else if(this.tabIdx == 1 && this.lableType == '1'){
					this.couponData();
				}
				
				if(this.isRefresh){
					setTimeout(() => {
				      	done();
				    }, 1500);	
				}else{
					setTimeout(() => {
				      	done(true);
				    }, 1500);
				};
			},
		}
	}
</script>



// WEBPACK FOOTER //
// src/components/mine/index.vue